import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import Navbar from '../components/Navbar'
import Hero from '../components/Hero'
import AppShowcaseSections from '../components/AppShowcaseSections'
import Features from '../components/Features'
import ChartShowcase from '../components/ChartShowcase'
import DispoEscape from '../components/DispoEscape'
import WhoWeHelp from '../components/WhoWeHelp'
import HowItWorks from '../components/HowItWorks'
import About from '../components/About'
import FAQ from '../components/FAQ'
import Contact from '../components/Contact'
import Waitlist from '../components/Waitlist'
import Footer from '../components/Footer'
import CookieConsent from '../components/CookieConsent'
import ScrollToTop from '../components/ScrollToTop'
import Chatbot from '../components/Chatbot'

export default function HomePage() {
  const location = useLocation()

  useEffect(() => {
    // Handle scrolling to section when navigating from feature pages
    if (location.state?.scrollTo) {
      const scrollTo = location.state.scrollTo
      // Clear the state to avoid re-scrolling on subsequent renders
      window.history.replaceState({}, document.title)
      
      // Wait for the page to render, then scroll
      setTimeout(() => {
        const element = document.getElementById(scrollTo)
        if (element) {
          const offset = 80
          const elementPosition = element.getBoundingClientRect().top
          const offsetPosition = elementPosition + window.pageYOffset - offset
          
          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          })
        }
      }, 300)
    }
  }, [location])

  return (
    <div className="min-h-screen bg-black overflow-x-hidden">
      <Navbar />
      <main>
        <Hero />
        <DispoEscape />
        <Features />
        <AppShowcaseSections />
        <ChartShowcase />
        <WhoWeHelp />
        <HowItWorks />
        <About />
        {/* FAQ Section - Häufige Fragen */}
        <FAQ />
        <Contact />
        <Waitlist />
      </main>
      <Footer />
      <CookieConsent />
      <ScrollToTop />
      <Chatbot />
    </div>
  )
}
